'use client';
import React, { useState } from 'react';
import Link from 'next/link';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) { setSubscribed(true); setEmail(''); }
  };

  return (
    <footer style={{ background: '#002266', color: '#fff', paddingTop: 48, paddingBottom: 24, marginTop: 32 }}>
      <div style={{ maxWidth: 1280, margin: '0 auto 32px', padding: '0 16px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 32 }}>
        {/* Brand */}
        <div>
          <Link href="/" style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16, textDecoration: 'none' }}>
            <div className="hero-gradient" style={{ width: 40, height: 40, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 9 6 2 18 2 18 9" />
                <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                <rect x="6" y="14" width="12" height="8" />
              </svg>
            </div>
            <div>
              <div style={{ fontWeight: 900, fontSize: 17, color: '#fff' }}>PRINTMOB HUB</div>
              <div style={{ fontSize: 10, color: '#93c5fd', letterSpacing: '0.1em' }}>DALLAS, TX — PRINTER STORE</div>
            </div>
          </Link>
          <p style={{ color: '#bfdbfe', fontSize: 13, lineHeight: 1.7 }}>
            Dallas&apos;s trusted independent authorized printer reseller. Quality products, expert support, unbeatable prices.
          </p>
          <p style={{ color: '#bfdbfe', fontSize: 13, marginTop: 10, lineHeight: 1.7 }}>
            📍 2338 Irving Blvd, Dallas, TX 75207<br />
            📞 <a href="tel:+12149638856" style={{ color: '#00b4d8', textDecoration: 'none' }}>+1 (214) 963-8856</a>
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <div style={{ fontWeight: 900, fontSize: 16, marginBottom: 16 }}>Quick Links</div>
          <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 8, fontSize: 14, color: '#bfdbfe' }}>
            {[['/', 'Home'], ['/shop', 'Shop'], ['/about', 'About Us'], ['/contact', 'Contact']].map(([href, label]) => (
              <li key={href}>
                <Link href={href} style={{ textDecoration: 'none', color: 'inherit', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = '#fff')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = '#bfdbfe')}
                >{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Tutorials */}
        <div>
          <div style={{ fontWeight: 900, fontSize: 16, marginBottom: 16 }}>Tutorials &amp; Guides</div>
          <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 8, fontSize: 14, color: '#bfdbfe' }}>
            <li>
              <Link href="/print" style={{ textDecoration: 'none', color: 'inherit' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = '#fff')}
                onMouseLeave={(e) => (e.currentTarget.style.color = '#bfdbfe')}
              >📘 123.hp.com Printer Setup Guide</Link>
            </li>
            <li>
              <Link href="/print" style={{ textDecoration: 'none', color: 'inherit' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = '#fff')}
                onMouseLeave={(e) => (e.currentTarget.style.color = '#bfdbfe')}
              >💾 Driver Download for Windows &amp; Mac</Link>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <div style={{ fontWeight: 900, fontSize: 16, marginBottom: 16 }}>Legal</div>
          <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 8, fontSize: 14, color: '#bfdbfe' }}>
            {[['/policies/terms', 'Terms & Conditions'], ['/policies/privacy', 'Privacy Policy'], ['/policies/refund', 'Refund Policy'], ['/policies/shipping', 'Shipping Policy']].map(([href, label]) => (
              <li key={href}>
                <Link href={href} style={{ textDecoration: 'none', color: 'inherit' }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = '#fff')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = '#bfdbfe')}
                >{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* We Accept + Newsletter */}
        <div>
          <div style={{ fontWeight: 900, fontSize: 16, marginBottom: 16 }}>We Accept</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginBottom: 24 }}>
            {/* VISA */}
            <div style={{ background: '#fff', borderRadius: 8, padding: '6px 10px', width: 60, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg viewBox="0 0 60 20" style={{ width: '100%' }}>
                <text x="2" y="15" fontFamily="Arial" fontWeight="900" fontSize="14" fill="#1A1F71" letterSpacing="1">VISA</text>
              </svg>
            </div>
            {/* Mastercard */}
            <div style={{ background: '#fff', borderRadius: 8, padding: '6px 10px', width: 60, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg viewBox="0 0 48 30" style={{ width: '100%', height: '100%' }}>
                <circle cx="17" cy="15" r="12" fill="#EB001B" />
                <circle cx="31" cy="15" r="12" fill="#F79E1B" />
                <path d="M24 6.2a12 12 0 0 1 0 17.6A12 12 0 0 1 24 6.2z" fill="#FF5F00" />
              </svg>
            </div>
            {/* AMEX */}
            <div style={{ background: '#fff', borderRadius: 8, padding: '6px 10px', width: 60, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg viewBox="0 0 60 20" style={{ width: '100%' }}>
                <text x="2" y="15" fontFamily="Arial" fontWeight="900" fontSize="10" fill="#2E77BC">AMEX</text>
              </svg>
            </div>
            {/* PayPal */}
            <div style={{ background: '#fff', borderRadius: 8, padding: '6px 10px', width: 60, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg viewBox="0 0 60 20" style={{ width: '100%' }}>
                <text x="2" y="15" fontFamily="Arial" fontWeight="900" fontSize="10" fill="#003087">Pay</text>
                <text x="22" y="15" fontFamily="Arial" fontWeight="900" fontSize="10" fill="#009cde">Pal</text>
              </svg>
            </div>
          </div>
          <div style={{ fontWeight: 900, fontSize: 16, marginBottom: 8 }}>Newsletter</div>
          <p style={{ color: '#bfdbfe', fontSize: 13, marginBottom: 10 }}>Get exclusive deals &amp; updates!</p>
          {subscribed ? (
            <p style={{ color: '#86efac', fontSize: 13 }}>✓ Subscribed! Thank you.</p>
          ) : (
            <form onSubmit={handleSubscribe} style={{ display: 'flex', gap: 8 }}>
              <input
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ flex: 1, background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 8, padding: '8px 12px', fontSize: 13, color: '#fff', outline: 'none' }}
              />
              <button
                type="submit"
                style={{ background: '#00b4d8', color: '#fff', padding: '8px 16px', borderRadius: 8, border: 'none', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}
              >Go</button>
            </form>
          )}
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: 20, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, maxWidth: 1280, margin: '0 auto', paddingLeft: 16, paddingRight: 16 }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 16, fontSize: 13, color: '#93c5fd' }}>
          <span>© 2024 Printmob Hub. All rights reserved.</span>
          <span>|</span>
          {[['/policies/terms', 'Terms'], ['/policies/privacy', 'Privacy'], ['/policies/refund', 'Refunds'], ['/policies/shipping', 'Shipping']].map(([href, label]) => (
            <Link key={href} href={href} style={{ textDecoration: 'none', color: 'inherit' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#fff')}
              onMouseLeave={(e) => (e.currentTarget.style.color = '#93c5fd')}
            >{label}</Link>
          ))}
        </div>
        <p style={{ color: '#60a5fa', fontSize: 12, maxWidth: 640, textAlign: 'center' }}>
          ℹ️ <strong style={{ color: '#93c5fd' }}>Disclaimer:</strong> Printmob Hub is an independent authorized reseller and is not directly affiliated with HP Inc. All logos, product names, and trademarks are the property of their respective owners and are referenced solely for product identification purposes.
        </p>
      </div>
    </footer>
  );
}
